import '@/styles/app.css'

import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import { bindRouterForAuthRedirect } from '@/lib/http'
import { useAuth } from '@/composables/useAuth'

bindRouterForAuthRedirect(router)

const { fetchUser } = useAuth()

fetchUser().finally(() => {
  const app = createApp(App)
  app.use(router)
  app.mount('#app')
})
